import React from "react";
import "./index.scss";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

class Dicas extends React.Component<{}> {
  render() {
    const dicas = [
      {
        title: "COMO PREPARAR O BRASEIRO PARA UM CHURRASCO PERFEITO",
        texto:
          "O segredo de um bom churrasco começa com um braseiro bem feito. O carvão deve ser de qualidade, preferencialmente natural, e a quantidade depende do tamanho da churrasqueira. Aqueça o carvão aos poucos, de forma que ele se acenda sem gerar chamas fortes. O ideal é que o braseiro esteja com as brasas vermelhas, mas sem fogo visível. Isso garante que a carne cozinhe de maneira uniforme e preserva o sabor. Uma boa dica é deixar o carvão em uma camada uniforme e, se possível, organizar as brasas de forma a criar diferentes zonas de calor – uma mais quente para selar a carne e outra mais amena para terminar o cozimento. A paciência aqui é a chave para um churrasco delicioso!",
      },
      {
        title: "O PONTO DA CARNE: DESCUBRA O SEU PREFERIDO",
        texto:
          "O ponto da carne é uma das questões mais debatidas quando se fala em churrasco. Cada tipo de carne, e até mesmo o gosto de quem vai saborear, pede um ponto diferente. Para quem gosta de carne bem passada, é preciso deixar a carne na grelha por mais tempo, o que pode fazer com que ela perca um pouco de suculência, mas mantém a maciez. Se você prefere uma carne mal passada, o tempo na grelha deve ser bem menor, garantindo mais sabor e suculência. O “ao ponto” é o meio-termo perfeito para quem busca equilíbrio entre sabor, suculência e crocância. Dica Domakoski: use o método de pressão com os dedos para conferir o ponto. Assim, você vai acertar de forma mais precisa!",
      },
      {
        title: "COMO PREPARAR FRUTAS NA GRELHA PARA SOBREMESA",
        texto:
          "Muitas vezes, o churrasco não termina na carne, e é aí que entram as frutas! Elas podem ser uma sobremesa maravilhosa quando preparadas na grelha. Frutas como abacaxi, pêssego, maçã ou até mesmo banana ficam deliciosas quando grelhadas. O calor da brasa carameliza os açúcares naturais das frutas, deixando um sabor incrível. Se você gosta de um toque extra, adicione um pouco de mel ou canela antes de colocar na grelha. O segredo é deixar as frutas dourarem por fora, mas sem perder a textura interna. Sirva como sobremesa ou até mesmo como acompanhamento da carne – uma combinação perfeita de sabores doces e salgados que vai surpreender o seu pessoal!",
      },
      {
        title: "COMO CALCULAR A QUANTIDADE DE CARNE POR PESSOA",
        texto:
          "Um erro comum em churrascos é calcular demais ou de menos a quantidade de carne, o que pode ser um desafio, especialmente se o número de convidados variar. A regra geral é calcular cerca de 300g a 400g de carne por pessoa, levando em consideração que sempre haverá acompanhamentos como arroz, saladas e farofa. Se for um evento maior, como um churrasco de celebração, pode aumentar um pouco essa quantidade. Se os cortes forem mais nobres ou se você for servir carnes como picanha, costela ou Angus, a porção pode ser reduzida. Lembre-se também de que a quantidade de carne crua perde um pouco de peso depois de assada, então, se for possível, aumente um pouco a conta. E não se esqueça de que, se sobrar, é sempre bom ter carne de qualidade para o dia seguinte!",
      },
      {
        title: "COMO AFIAR A FACA DE CHURRASCO DE FORMA EFICAZ",
        texto:
          "Uma boa faca de churrasco não só faz a diferença no corte, mas também na segurança e no prazer de comer. Faca cega é sinônimo de dificuldades, por isso é essencial manter suas facas sempre afiadas. O processo de afiação pode ser feito com um afiador manual, pedra de afiar ou até mesmo com uma lâmina de aço. Se você não tiver experiência, comece com um afiador manual, que é mais fácil de usar. Faça o movimento sempre no sentido certo, sem pressa, e com um ângulo de aproximadamente 20 graus. Se preferir a pedra, umedecê-la antes de usar pode ajudar a evitar desgaste excessivo. A dica é manter a lâmina em bom estado para cortes mais rápidos e sem esforço. E lembre-se: uma faca bem afiada vai deixar seu churrasco ainda mais prazeroso, sem riscos de acidentes!",
      },
    ];
    return (
      <>
        <Header />
        <div className="container-textos">
          <h1 style={{ textAlign: "left", width: "100%" }}>
            SUGESTÕES E TOQUES DO AÇOUGUE DOMAKOSKI PARA VOCÊ!
          </h1>
          <p>&nbsp;</p>
          <p style={{ textAlign: "justify", width: "100%" }}>
            Dicas diversas do Açougue Domakoski e equipe, seja para o seu
            churrasco ou as mais diversas ocasiões. Tudo para deixar seu dia a
            dia melhor e mais prático!
          </p>

          {dicas.map((dica) => (
            <>
              <hr
                style={{
                  width: "100%",
                  borderWidth: 1,
                  borderColor: "#CCCCCC",
                  borderStyle: "dotted",
                }}
              />
              <h3
                style={{
                  textAlign: "left",
                  width: "100%",
                  fontSize: "20px",
                  marginTop: 20,
                }}
              >
                {dica.title}
              </h3>
              <p
                style={{
                  textAlign: "justify",
                  width: "100%",
                  fontWeight: "normal",
                }}
              >
                {dica.texto}
              </p>
            </>
          ))}
        </div>
        <Footer />
      </>
    );
  }
}

export default Dicas;
